import { OwnerContractDetail, ReactSimpleComponentProps } from '@/custom-types';
import { useMemo, useState } from 'react';
import { OwnerContractDetailsContext, OwnerContractDetailsContextProps } from './OwnerContractDetailsContext';

export const OwnerContractDetailsContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [state, setState] = useState<OwnerContractDetail | undefined>(undefined)

  const actions = useMemo<Omit<OwnerContractDetailsContextProps, 'contract'>>(() => ({
    setContract: (contract: OwnerContractDetail | undefined) => setState(contract)
  }), [])

  return (
    <OwnerContractDetailsContext.Provider value={{ ...actions, contract: state }} >
      {children}
    </OwnerContractDetailsContext.Provider>
  )
}